// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-B":"B_cost-saving-B__B90B0"};